import RequestHelper from '../_request-helper'
import EventBus from '../_event-bus'

const BLUR_TIMEOUT = 200
const BASE_URL = process.env.BASE_URL
const SEARCH_ENDPOINT = process.env.SEARCH_ENDPOINT
const SEARCH_URL = process.env.SEARCH_URL
const SEARCH_PAGE = process.env.SEARCH_PAGE

export default {
  data() {
    return {
      isButtonClicked: false,
      isEnabledSearchBlur: true,
      isOpenSearch: false,
      searchMaxResults: 4,
      searchTerm: '',
    }
  },
  computed: {
    searchMoreUrl() {
      return encodeURI(`${BASE_URL}${SEARCH_PAGE}?${SEARCH_URL}=${this.searchTerm}`)
    },
  },
  methods: {
    searchHandleBlur,
    searchHandleClick,
  },
}

function searchHandleBlur() {
  setTimeout(() => {
    if (this.isButtonClicked) {
      this.isButtonClicked = false
      this.$refs.searchInput.focus()
    } else {
      this.isOpenSearch = false
      this.isButtonClicked = true
    }
  }, BLUR_TIMEOUT)
}

function searchHandleClick() {
  this.isButtonClicked = true

  setTimeout(async () => {
    if (this.isOpenSearch) {
      const payload = {
        params: {
          search: this.searchTerm,
        },
      }
      this.searchResults = []
      // this.searchResults = [
      //   {
      //     image: { alt: '', src: 'src/images/szkolenie-img@2x.png' },
      //     phrase: '…Pulneo, Desmoxan, Diohespan czy Opokan…',
      //     title: 'Aflofarm połączył siły z Trec Nutrition',
      //     type: 'Artykuł',
      //     url: '#one',
      //   },
      //   {
      //     image: { alt: '', src: 'src/images/szkolenie-img@2x.png' },
      //     title: 'two',
      //     type: 'Produkt',
      //     url: '#two',
      //   },
      //   {
      //     image: { alt: '', src: 'src/images/szkolenie-img@2x.png' },
      //     title: 'two',
      //     type: 'Produkt',
      //     url: '#two',
      //   },
      //   {
      //     image: { alt: '', src: 'src/images/szkolenie-img@2x.png' },
      //     title: 'two',
      //     type: 'Produkt',
      //     url: '#two',
      //   },
      //   {
      //     image: { alt: '', src: 'src/images/szkolenie-img@2x.png' },
      //     title: 'two',
      //     type: 'Produkt',
      //     url: '#two',
      //   },
      // ]
      try {
        const { data } = await RequestHelper.get(SEARCH_ENDPOINT, payload)
        if (data) {
          this.searchResults = data
          EventBus.$emit('header-search', { data: data })
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`error =>`, error)
      }
    } else {
      this.isOpenSearch = true
      this.$refs.searchInput.focus()
    }
  }, BLUR_TIMEOUT / 2)

  setTimeout(() => {
    this.isButtonClicked = false
  }, BLUR_TIMEOUT * 2)
}
